import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, removeCollaborator } from 'store/data/collaborators';

type HandlerInput = Parameters<typeof removeCollaborator>[0];

export function useRemoveCollaborator(): Operation<(input: HandlerInput) => void> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(ActionTypes.REMOVE_COLLABORATOR);

	function handler(input: HandlerInput) {
		if (loading) return;
		if (error) resetError();

		dispatch(removeCollaborator(input));
	}

	return [{ loading, error }, handler];
}
